import { motion } from "framer-motion";
import { education } from "../data/education";
import EducationItem from "../components/education/EducationItem";

const About = () => {
  return (
    <section className="page-shell space-y-14 md:space-y-20">
      {/* About Me Section */}
      <div className="page-panel flex flex-col items-center justify-center gap-8 rounded-3xl p-6 md:flex-row md:gap-12 md:p-10">
        {/* Profile Picture Animation */}
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-44 h-44 md:w-56 md:h-56 rounded-3xl overflow-hidden shadow-2xl ring-4 ring-[#e7efe9]"
        >
          <img
            src="/profile.jpg"
            alt="Amr El Shimy"
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Text Block Animation */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="page-card max-w-xl rounded-2xl p-6 md:p-8"
        >
          <p className="section-kicker mb-3 text-xs font-semibold uppercase tracking-[0.22em] md:text-sm">
            About
          </p>
          <h2 className="section-title mb-4 text-3xl font-bold md:text-4xl">
            Engineering elegant and scalable systems.
          </h2>
          <p className="body-copy text-sm leading-8 md:text-base">
            I'm an AWS Certified Developer and Full Stack Engineer specializing
            in scalable web applications and robust APIs using technologies like
            GraphQL, TypeScript, and Node.js. I love building clean, reliable
            systems and staying at the edge of tech trends — especially in
            backend architecture and DevOps.
          </p>
        </motion.div>
      </div>

      {/* Education Timeline */}
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="space-y-8"
      >
        <h3 className="section-title text-center text-3xl font-bold md:text-4xl">
          Education Journey
        </h3>
        <div className="space-y-10">
          {education.map((edu, i) => (
            <EducationItem key={i} edu={edu} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default About;
